import { Suspense, lazy, type ReactNode } from 'react';

import type { FileEntry } from '@/lib/api/generated/model';

/**
 * `@dnd-kit/*` must stay out of the entry bundle and out of every route that
 * never drags a row — this is the one place that boundary is drawn for the
 * files feature, mirroring `BoardCanvasLazy` and `PhaseStripLazy`.
 *
 * The listing renders as `children` *inside* the resolved layer, so it never
 * mounts with dragging half-available: until the chunk arrives the fallback
 * stands in its place, and once it does the listing sees the real bindings from
 * its very first render.
 */
const FileDragLayer = lazy(() =>
  import('./FileDragLayer').then((module) => ({
    default: module.FileDragLayer,
  })),
);

export function FileDragLayerLazy({
  entries,
  onMove,
  onDragActiveChange,
  fallback,
  children,
}: {
  entries: FileEntry[];
  onMove: (entry: FileEntry, destinationPath: string) => void;
  onDragActiveChange: (active: boolean) => void;
  fallback: ReactNode;
  children: ReactNode;
}) {
  return (
    <Suspense fallback={fallback}>
      <FileDragLayer
        entries={entries}
        onMove={onMove}
        onDragActiveChange={onDragActiveChange}
      >
        {children}
      </FileDragLayer>
    </Suspense>
  );
}
